require('./brokerConvenienceTestFailure.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { formatDate } = require('utilities/dateHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { taggingEventHandled } = require("utilities/taggingEventHandled");


// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @constants
const { DATE_FORMAT_SLASHED_ES, DATE_FORMAT } = require('constants/index');
const { PROC_BROKER_CONVENIENCE_TEST } = require('utilities/tagging');


class BrokerConvenienceTestFailure extends React.Component {


    componentDidMount () {
        const customData = {
            nombrePagina: "tu-inviertes/test-mifid",
            tipoProceso: "proc-tu-inviertes-test-mifid",
            pasoProceso: "error",
            detalleProceso: "respuestas incoherentes"
            };
        window && window.utag && window.utag.view && window.utag.view(customData)
    }

    cCContent() {
        const { immProfileFields, goToFirstStep, continueWithDisapprovedTest } = this.props;
        const clientName = <span>{PersonalDataHelper.getFullName(immProfileFields, false)}</span>;
        return(
            <div className="broker-convenience-test-failure-cc_container">
                <div className="broker-convenience-test-failure-cc__title">
                    <FormattedText value="broker-convenienceMifidDisapproveCCTitle" />
                </div>
                <ContentBox customClassName="broker-convenience-test-failure__box">
                    <div className="broker-convenience-test-failure-cc__disclaimer">
                        <BlockInfo>
                            <p className="broker-convenience-test-failure-cc__paragraph">
                                <FormattedTextWithComponents
                                    value="broker-convenienceMifidDisapproveCCContent1"
                                    injectedComponents={[
                                        clientName
                                    ]}
                                />
                            </p>
                            <p className="broker-convenience-test-failure-cc__paragraph">
                                <FormattedText value="broker-convenienceMifidDisapproveCCContent2" />
                            </p>
                            <p className="broker-convenience-test-failure-cc__paragraph">
                                <FormattedText value="broker-convenienceMifidDisapproveCCContent3" />
                            </p>
                        </BlockInfo>
                    </div>
                    <footer className="broker-convenience-test-failure-cc__footer text-center">
                        <div className="broker-convenience-test-failure-cc__continue-button-container">
                            <OKButton
                                modifier="ghost"
                                onClick={continueWithDisapprovedTest}
                            >
                                <FormattedText value="broker-convenienceMifidDisapproveCCButtonContinue" />
                            </OKButton>
                        </div>
                        <div className="broker-convenience-test-failure-cc__review-button-container">
                            <OKButton
                                modifier="secondary"
                                onClick={goToFirstStep}
                            >
                                <FormattedText value="broker-convenienceMifidDisapproveCCButtonReview" />
                            </OKButton>
                        </div>
                    </footer>
                </ContentBox>
            </div>
        );
    }

    webappContent() {
        const {immBrokerConvenienceMiFIDTest} = this.props;
        const rawDate = immBrokerConvenienceMiFIDTest.getIn(['test', 'testToEvaluate', 'lastDateTest'], '');
        const date = rawDate
            ? formatDate(moment(rawDate, DATE_FORMAT_SLASHED_ES), DATE_FORMAT)
            : '-'
        const doTagging = ()=> {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onFailureTestByIncoherence')
        }
        return (
            <div className="broker-convenience-test-failure__container">
                <ContentBox customClassName="broker-convenience-test-failure__box">
                    <div className="broker-convenience-test-failure__content">
                        <p className="broker-convenience-test-failure__paragraph">
                            <FormattedTextWithComponents
                                value="broker-convenienceMifidDisapproveTestContent1"
                                injectedComponents={[
                                    date
                                ]}
                            />
                        </p>
                        <p className="broker-convenience-test-failure__paragraph">
                            <FormattedText value="broker-convenienceMifidDisapproveTestContent2" />
                        </p>
                    </div>
                    <footer className="broker-convenience-test-failure__footer text-center">
                        <OKButton
                            modifier="secondary"
                            to="/myprofile/broker/general"
                            onClick={()=> doTagging()}
                        >
                            <FormattedText value="broker-convenienceMifidDisapproveTestButtonText" />
                        </OKButton>
                    </footer>
                </ContentBox>
            </div>
        );
    }

    render() {
        return __CONTACT_CENTER__ ? this.cCContent() : this.webappContent();
    }
}

BrokerConvenienceTestFailure.propTypes = {
    email: PropTypes.string.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    goToFirstStep: PropTypes.func.isRequired,
    continueWithDisapprovedTest: PropTypes.func.isRequired
};

module.exports = BrokerConvenienceTestFailure;
